import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Tooltip } from "../../../../utils/local-antd";

import { Button } from "../../../../components/Button";
import { Flex } from "../../../../components/Flex";
import { Text } from "../../../../components/Text";
import { integrationSliceSelectors } from "../../../../redux/integration/integration.selector";
import { useAppSelector } from "../../../../redux/store";
import { useIntegrationContext } from "../../context/integration-context";
import { IntegrationSection } from "../IntegrationSection";
import { Spacing } from "../../../../theme/Spacing";

const StyledButton = styled(Button)`
  background-color: transparent;
  color: ${({ theme }) => theme.main};
  margin-inline-start: auto;
  padding: ${Spacing.xs};
`;

export const IntegrationFBSection: React.FC = () => {
  const { setAddModalFacebookVisible } = useIntegrationContext();
  const { t } = useTranslation();

  const integration = useAppSelector(
    integrationSliceSelectors.selectFBIntegration,
  );
  const isEnabled = integration?.status.enabled;

  if (!integration) {
    return null;
  }

  return (
    <IntegrationSection
      enabled={isEnabled}
      icon={faFacebook}
      iconColor="facebook"
    >
      <Flex gap="s" alignItems="center" justifyContent="center" width={"100%"}>
        <Text fontSize="l">
          {integration.status.isReady
            ? t("common.ready")
            : t("common.not-ready")}
        </Text>

        <Tooltip title={t("common.edit")}>
          <StyledButton
            icon={faEdit}
            onClick={() => setAddModalFacebookVisible(true)}
            iconWidth="2xl"
          />
        </Tooltip>
      </Flex>
    </IntegrationSection>
  );
};
